import { Owner, OwnerStatus } from "../../models/owner.model"
import { Tenant } from "../../models/tenant.model"

export function isUserActive(
  userInfo: any,
  ownerInfo: Owner,
  tenantInfo: Tenant,
): boolean {
  if (userInfo?.role?.key === "super_admin") return true

  if (userInfo?.role?.key === "tenant") {
    // Check for tenant
    return tenantInfo?.owner?.parentOwner?.ownerStatus === OwnerStatus.Active
  } else if (userInfo?.role?.key === "owner") {
    // Check for owner
    return ownerInfo?.parentOwner?.ownerStatus === OwnerStatus.Active
  }

  // Default case (if role is neither tenant nor owner)
  return false
}
